/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type AccountNavContent_user$ref = any;
export type AccountNavContent_user = {
    readonly profile: {
        readonly email: string | null;
    } | null;
    readonly authMetadata: {
        readonly emailOnly: boolean | null;
    } | null;
    readonly " $refType": AccountNavContent_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "AccountNavContent_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "email",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "authMetadata",
      "storageKey": null,
      "args": null,
      "concreteType": "UserExistsMetadataType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "emailOnly",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'ec8028f7e94b381c3e82028beafe5dbf';
export default node;
